import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import api from "../../../api/api";
import Images from "../../../media/images";

const Profile = () => {
  const [user, setUser] = useState({})

  useEffect(() => {
    api.get('/users/me/')
    .then(response=> {
      // console.log(response.data[0])
      setUser(response.data[0])
    }).catch(error=> {
      console.log(error)
    })
  }, [])
  

  return (
    <div className="shadow-2xl">
      <h1 className="text-primary-red font-Rakkas mt-2 text-center text-4xl font-bold lg:!mt-6">
        Profile
      </h1>
      <div className="">
        <img src={Images.title_border} alt="" className="mx-auto mt-4" />
      </div>
      <div className="mt-10 grid place-content-center place-items-center rounded-xl py-10 ">
        <div className="gap-20 sm:flex">
          <div className="h-28 w-28">
            {
              user?.profile?.image ?  <img
              className="h-full w-full rounded-full object-cover"
              // src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZmlsZXxlbnwwfHwwfHw%3D&w=1000&q=80"
                src = {user?.profile?.image}
              alt=""
            />:<img
            className="h-full w-full rounded-full object-cover"
            src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mnx8cHJvZmlsZXxlbnwwfHwwfHw%3D&w=1000&q=80"
              // src = {user?.profile?.image}
            alt=""
          />
              
            }
           
          </div>
          <div className="mt-10">

            <Link to={`../edit-profile/`+user.id}>
            <div
              className="bg-primary-blue font-Berkshire animation mt-5 rounded-xl px-5 py-3 text-white hover:bg-blue-900 lg:mt-0"
            >
              Edit Profile
            </div>
            </Link>
            
          </div>
        </div>
        <div className="border-primary-blue font-Acme my-10 grid place-content-center space-y-5 rounded-2xl border-2 p-5 text-left">
          <h1 className="text-primary-red font-bold md:text-xl">
            Name :<span className="text-primary-blue">
              {user?.profile?.f_name} &nbsp; {user?.profile?.l_name}
              
            </span>
          </h1>
          <h1 className="text-primary-red font-bold md:text-xl">
            Address :
            <span className="text-primary-blue">{user?.profile?.address ?? "Not Updated"}</span>
          </h1>
          <h1 className="text-primary-red font-bold md:text-xl">
            Contact : <span className="text-primary-blue">{user?.phone ?? "Contact not set"}</span>
          </h1>
          <h1 className="text-primary-red font-bold md:text-xl">
            Email :<span className="text-primary-blue">{user?.email ?? "Email Not set"}</span>
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Profile;
